import Home from "./home"
import Chaine from "./chaine"
import Pricing from "./pricing"
import How from "./how"
import Sports from "./sports"
import Device from "./device"
import Review from "./review"
import Faq from "./faq"


export default function All(){
    return(
        <>
            <Home/>
            <Chaine/>
            <Sports/>
            <Pricing/>
            <How/>
            <Device/>
            <Review/>
            <Faq/>
        </>
    )
}